require('../../../core/frontend/vendor_modules/jquery-2.1.4.js');

$.extend($.fn, {
  setCursorPosition: (function(pos) {
    var elem, range;
    if (this.length > 0) {
      elem = this.get(0);
      if (elem != null) {
        if (elem.setSelectionRange != null) {
          return elem.setSelectionRange(pos, pos);
        } else if (elem.createTextRange != null) {
          range = elem.createTextRange();
          range.collapse(true);
          range.moveEnd('character', pos);
          range.moveStart('character', pos);
          return range.select();
        }
      }
    }
  }),
  placeholderInput: (function() {
    var inputField, nativePlaceholder;
    inputField = $(this);
    nativePlaceholder = document.createElement('input').placeholder !== void 0 && navigator.appVersion.indexOf("MSIE") === -1;
    if (!nativePlaceholder && (inputField.attr('placeholder') != null)) {
      inputField.keypress(function() {
        if ($(this).val() === $(this).attr('placeholder')) {
          $(this).css({
            color: '#333333'
          });
          return $(this).val('');
        }
      });
      inputField.keyup(function() {
        if ($(this).val() !== '') {
          if ($(this).val() !== $(this).attr('placeholder')) {
            return $(this).css({
              color: '#333333'
            });
          }
        } else {
          $(this).css({
            color: '#888888'
          });
          $(this).val(inputField.attr('placeholder'));
          return $(this).setCursorPosition(0);
        }
      });
      if (inputField.val() === '') {
        inputField.css({
          color: '#888888'
        });
        inputField.val(inputField.attr('placeholder'));
        return inputField.setCursorPosition(0);
      }
    }
  })
});

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvc3JhamVuZHJhbi9uYXBpc3RyYW5vL2J1aWxkLzE1MTU0OTM1MTMxODktODY0MS9wcm9kdWN0aW9uLTIwMTguMDEuMDlfMDkuNTEvc3Vic2NyaXB0aW9uX2Zsb3cvbW9kdWxlcy9zdWJzY3JpcHRpb24vZnJvbnRlbmQvcGxhY2Vob2xkZXJfaW5wdXQuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvc3JhamVuZHJhbi9uYXBpc3RyYW5vL2J1aWxkLzE1MTU0OTM1MTMxODktODY0MS9wcm9kdWN0aW9uLTIwMTguMDEuMDlfMDkuNTEvc3Vic2NyaXB0aW9uX2Zsb3cvbW9kdWxlcy9zdWJzY3JpcHRpb24vZnJvbnRlbmQvcGxhY2Vob2xkZXJfaW5wdXQuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVNBLE9BQUEsQ0FBUSx1REFBUjs7QUFFQSxDQUFDLENBQUMsTUFBRixDQUFTLENBQUMsQ0FBQyxFQUFYLEVBQ0U7RUFBQSxpQkFBQSxFQUFtQixDQUFFLFNBQUMsR0FBRDtBQUNuQixRQUFBO0lBQUEsSUFBRyxJQUFJLENBQUMsTUFBTCxHQUFjLENBQWpCO01BQ0UsSUFBQSxHQUFPLElBQUksQ0FBQyxHQUFMLENBQVMsQ0FBVDtNQUNQLElBQUcsWUFBSDtRQUNFLElBQUcsOEJBQUg7aUJBQ0UsSUFBSSxDQUFDLGlCQUFMLENBQXVCLEdBQXZCLEVBQTRCLEdBQTVCLEVBREY7U0FBQSxNQUVLLElBQUcsNEJBQUg7VUFDSCxLQUFBLEdBQVEsSUFBSSxDQUFDLGVBQUwsQ0FBQTtVQUNSLEtBQUssQ0FBQyxRQUFOLENBQWUsSUFBZjtVQUNBLEtBQUssQ0FBQyxPQUFOLENBQWMsV0FBZCxFQUEyQixHQUEzQjtVQUNBLEtBQUssQ0FBQyxTQUFOLENBQWdCLFdBQWhCLEVBQTZCLEdBQTdCO2lCQUNBLEtBQUssQ0FBQyxNQUFOLENBQUEsRUFMRztTQUhQO09BRkY7O0VBRG1CLENBQUYsQ0FBbkI7RUFjQSxnQkFBQSxFQUFrQixDQUFDLFNBQUE7QUFFakIsUUFBQTtJQUFBLFVBQUEsR0FBYSxDQUFBLENBQUUsSUFBRjtJQUNiLGlCQUFBLEdBQW9CLFFBQVEsQ0FBQyxhQUFULENBQXVCLE9BQXZCLENBQStCLENBQUMsV0FBaEMsS0FBK0MsTUFBL0MsSUFBNEQsU0FBUyxDQUFDLFVBQVUsQ0FBQyxPQUFyQixDQUE2QixNQUE3QixDQUFBLEtBQXdDLENBQUM7SUFDekgsSUFBRyxDQUFDLGlCQUFELElBQXNCLHdDQUF6QjtNQUNFLFVBQVUsQ0FBQyxRQUFYLENBQXFCLFNBQUE7UUFDbkIsSUFBRyxDQUFBLENBQUUsSUFBRixDQUFPLENBQUMsR0FBUixDQUFBLENBQUEsS0FBaUIsQ0FBQSxDQUFFLElBQUYsQ0FBTyxDQUFDLElBQVIsQ0FBYSxhQUFiLENBQXBCO1VBQ0UsQ0FBQSxDQUFFLElBQUYsQ0FBTyxDQUFDLEdBQVIsQ0FBWTtZQUFDLEtBQUEsRUFBTyxTQUFSO1dBQVo7aUJBQ0EsQ0FBQSxDQUFFLElBQUYsQ0FBTyxDQUFDLEdBQVIsQ0FBWSxFQUFaLEVBRkY7O01BRG1CLENBQXJCO01BS0EsVUFBVSxDQUFDLEtBQVgsQ0FBa0IsU0FBQTtRQUNoQixJQUFHLENBQUEsQ0FBRSxJQUFGLENBQU8sQ0FBQyxHQUFSLENBQUEsQ0FBQSxLQUFpQixFQUFwQjtVQUNFLElBQUcsQ0FBQSxDQUFFLElBQUYsQ0FBTyxDQUFDLEdBQVIsQ0FBQSxDQUFBLEtBQWlCLENBQUEsQ0FBRSxJQUFGLENBQU8sQ0FBQyxJQUFSLENBQWEsYUFBYixDQUFwQjttQkFDRSxDQUFBLENBQUUsSUFBRixDQUFPLENBQUMsR0FBUixDQUFZO2NBQUMsS0FBQSxFQUFPLFNBQVI7YUFBWixFQURGO1dBREY7U0FBQSxNQUFBO1VBSUUsQ0FBQSxDQUFFLElBQUYsQ0FBTyxDQUFDLEdBQVIsQ0FBWTtZQUFDLEtBQUEsRUFBTyxTQUFSO1dBQVo7VUFDQSxDQUFBLENBQUUsSUFBRixDQUFPLENBQUMsR0FBUixDQUFZLFVBQVUsQ0FBQyxJQUFYLENBQWdCLGFBQWhCLENBQVo7aUJBQ0EsQ0FBQSxDQUFFLElBQUYsQ0FBTyxDQUFDLGlCQUFSLENBQTBCLENBQTFCLEVBTkY7O01BRGdCLENBQWxCO01BU0EsSUFBRyxVQUFVLENBQUMsR0FBWCxDQUFBLENBQUEsS0FBb0IsRUFBdkI7UUFDRSxVQUFVLENBQUMsR0FBWCxDQUFlO1VBQUMsS0FBQSxFQUFPLFNBQVI7U0FBZjtRQUNBLFVBQVUsQ0FBQyxHQUFYLENBQWUsVUFBVSxDQUFDLElBQVgsQ0FBZ0IsYUFBaEIsQ0FBZjtlQUNBLFVBQVUsQ0FBQyxpQkFBWCxDQUE2QixDQUE3QixFQUhGO09BZkY7O0VBSmlCLENBQUQsQ0FkbEI7Q0FERiJ9
